export const therapeuticMaterialFamilyValues = [
    "crown",
    "implantCrown",
    "tempCrown",
    "implantAbutment",
    "inlayCore",
];
export const therapeuticMaterialFamilyLabels = {
    crown: "Couronne",
    implantCrown: "Couronne sur implant",
    tempCrown: "Couronne provisoire",
    implantAbutment: "Pilier implantaire",
    inlayCore: "Inlay-core",
};
export const crownMaterials = [
    {
        code: "PFMNP",
        frenchLabel: "CCM-Non Précieux",
    },
    {
        code: "PFMSemi",
        frenchLabel: "CCM-Semi Précieux",
    },
    {
        code: "PFMPrecious",
        frenchLabel: "CCM-Précieux",
    },
    {
        code: "ZircoMono",
        frenchLabel: "Zircone Monolithique Simple",
    },
    {
        code: "ZircoMonoEsthe",
        frenchLabel: "Zircone Monolithique Esthétique",
    },
    {
        code: "PFZ",
        frenchLabel: "Zircone Stratifiée",
    },
    {
        code: "NonPreciousMetal",
        frenchLabel: "Couronne coulée en métal non précieux",
    },
    {
        code: "PreciousMetal",
        frenchLabel: "Couronne coulée en métal précieux",
    },
    {
        code: "EmaxMono",
        frenchLabel: "Couronne disilicate (Emax) monolithique",
    },
    {
        code: "EmaxStrat",
        frenchLabel: "Couronne disilicate (Emax) stratifiée/cut-back",
    },
];
export const tempCrownMaterials = [
    {
        code: "Resin",
        frenchLabel: "Couronne en résine",
    },
];
export const implantAbutmentMaterials = [
    {
        code: "Titanium",
        frenchLabel: "Pilier en titane",
        selectLabel: "Titane",
    },
    {
        code: "NPMetal",
        frenchLabel: "Pilier en métal non précieux",
    },
    {
        code: "PreciousMetal",
        frenchLabel: "Pilier en métal précieux",
    },
    {
        code: "CoCr",
        frenchLabel: "Pilier en alliage non précieux CoCr",
        selectLabel: "Alliage non précieux CoCr - NF EN ISO 22674 3-2007",
    },
    {
        code: "NiCr",
        frenchLabel: "Pilier en alliage non précieux NiCr",
        selectLabel: "Alliage non précieux NiCr - NF EN ISO 22674 3-2007",
    },
    {
        code: "PreciousAlloy",
        frenchLabel: "Pilier en alliage précieux",
        selectLabel: "Alliage précieux NF EN ISO 22674 3-2007",
    },
    {
        code: "SemiPreciousAlloy",
        frenchLabel: "Pilier en alliage semi précieux",
        selectLabel: "Alliage semi précieux NF EN ISO 22674 3-2007",
    },
    {
        code: "CeramoDental",
        frenchLabel: "Pilier en céramo dentaire",
        selectLabel: "Céramo dentaire NF EN ISO 6872 1999",
    },
];
export const inlayCoreMaterials = [
    {
        code: "CoCr",
        frenchLabel: "Alliage non précieux CoCr",
        selectLabel: "Alliage non précieux CoCr - NF EN ISO 22674 3-2007",
    },
    {
        code: "NiCr",
        frenchLabel: "Alliage non précieux NiCr",
        selectLabel: "Alliage non précieux NiCr - NF EN ISO 22674 3-2007",
    },
    { code: "Titanium", frenchLabel: "Titane", selectLabel: "Titane" },
    {
        code: "PreciousAlloy",
        frenchLabel: "Alliage précieux",
        selectLabel: "Alliage précieux NF EN ISO 22674 3-2007",
    },
    {
        code: "SemiPreciousAlloy",
        frenchLabel: "Alliage semi précieux",
        selectLabel: "Alliage semi précieux NF EN ISO 22674 3-2007",
    },
];
export const therapeuticMaterialCodeValues = [
    ...crownMaterials.map((item) => item.code),
    ...tempCrownMaterials.map((item) => item.code),
    ...implantAbutmentMaterials.map((item) => item.code),
];
const therapeuticMaterialsByFamily = {
    crown: crownMaterials,
    implantCrown: crownMaterials,
    tempCrown: tempCrownMaterials,
    implantAbutment: implantAbutmentMaterials,
    inlayCore: inlayCoreMaterials,
};
const networkMaterialRestrictions = {
    santeclair: {
        implantAbutment: ["CoCr", "PreciousAlloy"],
        inlayCore: ["CoCr"],
    },
    itelis: {
        implantAbutment: [
            "Titanium",
            "CoCr",
            "NiCr",
            "PreciousAlloy",
            "SemiPreciousAlloy",
        ],
        inlayCore: [
            "Titanium",
            "CoCr",
            "NiCr",
            "PreciousAlloy",
            "SemiPreciousAlloy",
        ],
    },
};
export function getTherapeuticMaterialOptions(family) {
    return therapeuticMaterialsByFamily[family].map((item) => ({
        code: item.code,
        family,
        frenchLabel: item.frenchLabel,
        selectLabel: "selectLabel" in item && item.selectLabel
            ? item.selectLabel
            : item.frenchLabel,
    }));
}
export function getAllowedTherapeuticMaterialOptions(options) {
    const allOptions = getTherapeuticMaterialOptions(options.family);
    if (!options.network) {
        return allOptions;
    }
    const allowedCodes = getNetworkMaterialRestriction(options.network, options.family);
    if (!allowedCodes) {
        return allOptions;
    }
    return allOptions.filter((option) => allowedCodes.includes(option.code));
}
export function isTherapeuticMaterialCodeAllowed(options) {
    return getAllowedTherapeuticMaterialOptions({
        family: options.family,
        network: options.network,
    }).some((option) => option.code === options.materialCode);
}
export function getTherapeuticMaterialOptionByCode(materialCode) {
    const families = [
        "crown",
        "implantCrown",
        "tempCrown",
        "implantAbutment",
        "inlayCore",
    ];
    for (const family of families) {
        const found = getTherapeuticMaterialOptions(family).find((option) => option.code === materialCode);
        if (found) {
            return found;
        }
    }
    return null;
}
function getNetworkMaterialRestriction(network, family) {
    if (family === "inlayCore" && network === "santeclair") {
        return networkMaterialRestrictions.santeclair.inlayCore;
    }
    if (family === "inlayCore" && network === "itelis") {
        return networkMaterialRestrictions.itelis.inlayCore;
    }
    if (family !== "implantAbutment") {
        return undefined;
    }
    if (network === "santeclair") {
        return networkMaterialRestrictions.santeclair.implantAbutment;
    }
    if (network === "itelis") {
        return networkMaterialRestrictions.itelis.implantAbutment;
    }
    return undefined;
}
//# sourceMappingURL=materiaux.js.map